import React from "react";
import { useLocation } from "react-router-dom";

export function CheckPathname (){
    const urlLocation=useLocation();

    let showDemandButton=true
    let logoutStatus=false
    let surveyID=0
        if( urlLocation.pathname=="/app/municipality" ||urlLocation.pathname=="/app/municipality/"){
            logoutStatus=true
            showDemandButton=false
            surveyID=3				
        }
        else if( urlLocation.pathname=="/app/entity"||urlLocation.pathname=="/app/entity/"){
            logoutStatus=true
            showDemandButton=false
            surveyID=5
        }
        else{
            showDemandButton=true
            logoutStatus=false
            surveyID=2
        }
    let loginStatus=!logoutStatus	 
    let pathnameCheck={logoutStatus,surveyID,showDemandButton,loginStatus}
    return pathnameCheck
};